/**
 * @file Data set to retrieve data without a component.
 * @author Tom Verschoore de la Houssaije
 */
import * as tslib_1 from "tslib";
import { EventEmitter } from '@angular/core';
import { AbstractBase } from '../../core/helpers/abstract-base';
/** Data set to retrieve data without a component. */
var DataSet = /** @class */ (function (_super) {
    tslib_1.__extends(DataSet, _super);
    /**
     * Creates an instance of DataSet.
     * @param {BreezeService} [dataService] The breeze service.
     * @memberOf DataSet
     */
    function DataSet(dataService) {
        var _this = _super.call(this) || this;
        _this.dataService = dataService;
        /** The items retrieved. */
        _this.items = [];
        /** Sorting rules used to create the EntityQuery */
        _this.sorting = [];
        /** Gets Sets the total number of entities that complies to the the requested query. */
        _this.inlineCount = 0;
        /**
         * The event is triggered when a new data set is retrieved from the back-end.
         * @type {EventEmitter<QueryResult>}
         * @memberOf DataSet
         */
        _this.onRefresh = new EventEmitter();
        return _this;
    }
    /**
     * Reloads the data set.
     * @returns {Promise<QueryResult>} A promise for the query results.
     * @memberOf DataSet
     */
    DataSet.prototype.refresh = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.dataService) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.dataService.getDataSet(this, this.items)];
                    case 1:
                        result = _a.sent();
                        this.onRefresh.emit(result);
                        return [2 /*return*/, result];
                    case 2: throw new Error('Refresh is not implemented for this DataSet.');
                }
            });
        });
    };
    /**
     * Loads the entities.
     * @param {string} entityName The name of the entity type.
     * @returns {Promise<QueryResult>} A promise for the query results.
     * @memberOf DataSet
     */
    DataSet.prototype.load = function (entityName) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.dataService) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.dataService.registerAndLoadSource(entityName, this, this.items)];
                    case 1:
                        result = _a.sent();
                        this.onRefresh.emit(result);
                        return [2 /*return*/, result];
                    case 2: throw new Error('Load is not implemented for this DataSet.');
                }
            });
        });
    };
    DataSet.prototype.register = function (entityName) {
        if (this.dataService) {
            this.entityType = this.dataService.getEntityType(entityName);
            return this;
        }
        throw new Error('Register is not implemented for this DataSet.');
    };
    /**
     * Adds the entity to the data set and data service.
     * @param {Entity} entity The entity to be added.
     * @memberOf DataSet
     */
    DataSet.prototype.add = function (entity) {
        this.dataService.addEntity(entity);
        this.items.push(entity);
    };
    /**
     * Removes the entity from the data set and marks it as deleted.
     * @param {Entity} entity The entity to be removed.
     * @memberOf DataSet
     */
    DataSet.prototype.remove = function (entity) {
        var index = this.items.indexOf(entity);
        if (index === -1) {
            console.warn('The entity was not part of this data set');
        }
        else {
            entity.entityAspect.setDeleted();
            this.items.splice(index, 1);
        }
    };
    return DataSet;
}(AbstractBase));
export { DataSet };
